// import { canUseDOM } from 'exenv';

export function tagFeaturedFeedLoading(resp = {}, store = {}) {
  return {
    type: 'TAG_FEATURED_FEED_LOADING',
    tagFeaturedFeed: resp,
    store
  };
}

export function tagFeaturedFeedLoaded(resp = {}, store = {}) {
  return {
    type: 'TAG_FEATURED_FEED_LOADED',
    tagFeaturedFeed: {
      featured: resp.featured,
      top: resp.top,
      tag: resp.tag,
      source: resp.source
    },
    store
  };
}

export function tagFeaturedFeedLoadError(error, store = {}) {
  return {
    type: 'TAG_FEATURED_FEED_ERROR',
    tagFeaturedFeed: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
